<template>
    <div>
        <div class="dataTitle">
            <div class="title">{{title}}</div>
            <div style="display: flex;justify-content: center;align-items: center;">
                <InputField label="" type="text" label-width="0%" id="partitionName" style="margin-right: 1rem;"
                            :modelValue="preForm.floodAreasName" placeholder="请输入易涝点名称"
                            @update:modelValue="(value) => handleModelPreValueUpdate('floodAreasName', value)"/>
                <a-space>
                    <ButtonField style="width: 80px;" text="查询" secondary @click="getFloodPtsList"/>
                    <ButtonField style="width: 80px;" text="新增" @click="add" primary />
                </a-space>
            </div>
        </div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="preForm.totalSize"
            :totalPages="preForm.totalPages"
            :pageNum="preForm.pageNum"
            :pageSize="preForm.pageSize"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="editShow?'编辑易涝点':'新增易涝点'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <div>
                        <InputField label="易涝点编号" type="text"  id="floodAreasCode" labelWidth="80%"
                                    :modelValue="form.floodAreasCode" placeholder="请输入易涝点编号"
                                    @update:modelValue="(value) => handleModelValueUpdate('floodAreasCode', value)"/>
                    </div>
                    <div>
                        <InputField label="易涝点名称" type="text"  id="floodAreasName" labelWidth="80%"
                                    :modelValue="form.floodAreasName" placeholder="请输入易涝点名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('floodAreasName', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="积水深度(厘米)" type="Number"  id="depth" labelWidth="80%"
                                    :modelValue="form.depth" placeholder="请输入积水深度(厘米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('depth', value)"/>
                    </div>
                    <div>
                        <InputField label="触发降雨强度(mm/h)" type="Number"  id="rainIntensity" labelWidth="80%"
                                    :modelValue="form.rainIntensity" placeholder="请输入触发降雨强度(mm/h)"
                                    @update:modelValue="(value) => handleModelValueUpdate('rainIntensity', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="重现期" type="Number"  id="returnPeriod" labelWidth="80%"
                                    :modelValue="form.returnPeriod" placeholder="请输入重现期"
                                    @update:modelValue="(value) => handleModelValueUpdate('returnPeriod', value)"/>
                    </div>
                    <div>
                        <InputField label="积水持续时间(小时)" type="Number"  id="continueTime" labelWidth="80%"
                                    :modelValue="form.continueTime" placeholder="请输入积水持续时间(小时)"
                                    @update:modelValue="(value) => handleModelValueUpdate('continueTime', value)"/>
                    </div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" v-if="!saveShow" primary @click="handleSubmit"/>
                        <ButtonField text="下一步" v-else primary @click="handleNextStep"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import {
    fetchFloodPtsPageList,
    saveFloodPtsPage,
    modifyFloodPtsPage,
    remove,
} from "../api/diagnose";
export default {
    name: "index",
    data() {
        return {
            preForm:{
                totalSize: 1,
                totalPages: 1,
                pageNum: 1,
                pageSize: 10,
            },
            form:{
                floodAreasCode:null,floodAreasName:null,depth:null,rainIntensity:null,returnPeriod:null,continueTime:null
            },
            visible:false,
            editShow:false,
            saveShow:false,
            list:[],
            tableColumns:[
                {key: 'floodAreasCode',title: '易涝点编号',field: 'floodAreasCode',width: '100px'},
                {key: 'floodAreasName',title: '易涝点名称',field: 'floodAreasName',width: '100px'},
                {key: 'depth',title: '积水深度（厘米）',field: 'depth',width: '100px'},
                {key: 'rainIntensity',title: '触发降雨强度（mm/h）',field: 'rainIntensity',width: '100px'},
                {key: 'returnPeriod',title: '重现期',field: 'returnPeriod',width: '100px'},
                {key: 'continueTime',title: '积水持续时间（小时）',field: 'continueTime',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ]
        }
    },
    props:{
        title: {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.getFloodPtsList();
    },
    methods: {
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getFloodPtsList();
        },
        getFloodPtsList(){
            fetchFloodPtsPageList(this.preForm).then(res => {
                this.list = res.list.map(item => ({
                    ...item,
                    daytime: this.formatDate(item.daytime)
                }));
                this.preForm.totalPages = res.totalPages;
                this.preForm.totalSize = res.totalSize;
            })
        },
        handleModelPreValueUpdate(fieldName, value){
            this.preForm[fieldName] = value;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        add(){
            this.visible = true;
            this.editShow = false;
            this.saveShow = false;
            this.form = {}
        },
        editText(item){
            console.log("item:::",item)
            this.visible = true;
            this.editShow = true;
            this.saveShow = false;
            this.form = item;
        },
        deleteText(item){
            remove({
                id: item.id,
                type: "diagnose_flood_pts"
            }).then((res) => {
                console.log("res:", res);
                this.getFloodPtsList();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        cancel() {
            this.visible = false;
        },
        handleSubmit(){
            this.form.daytime = new Date();
            if(this.form.id){
                modifyFloodPtsPage(this.form).then(res => {
                    console.log(" res:::",res)
                    this.getFloodPtsList()
                })
            }else{
                saveFloodPtsPage(this.form).then(res => {
                    console.log(" res:::",res)
                    this.getFloodPtsList()
                })
            }
            this.saveShow = true
        },
        handleNextStep(){
            this.visible = false;
            this.$bus.$emit('switch-component', 'wwtPlantOp');
        }
    }
}
</script>
<style scoped>
.dataTitle{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 1rem 0;
}
.title{
    font-size: 1.2rem;
    color: #00ff96;
    font-weight: bold;
}
.formDiv{
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
}
.formDiv > div{
    width: 48%;
}
</style>